import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../Checkbox';
import { Button } from './styles';

const CheckboxButton = memo(
  ({ checked, title, children, bold, checkPosition, size, ...props }) => {
    return (
      <Button title={title} {...props}>
        <Checkbox
          checked={checked}
          renderInput={false}
          bold={bold}
          checkPosition={checkPosition}
          size={size}
          disabled={props.disabled}
        >
          {children}
        </Checkbox>
      </Button>
    );
  }
);

CheckboxButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  title: PropTypes.string,
  checked: PropTypes.bool,
  bold: PropTypes.bool,
  checkPosition: PropTypes.oneOf(['start', 'end']),
  size: PropTypes.oneOf(['md', 'lg']),
  disabled: PropTypes.bool,
};

CheckboxButton.defaultProps = {
  children: '',
  title: '',
  checked: false,
  bold: false,
  checkPosition: 'end',
  size: 'md',
  disabled: false,
};

export default CheckboxButton;
